import {useState, useEffect, useRef} from 'react'
import {connect} from 'react-redux'
import {Map} from 'immutable'
import PropTypes from 'prop-types'
import {deleteResource, readEndpoint} from 'redux-json-api'

import {cleanResponse} from '../redux/apiHelper'
import {useNotificationContext} from '../../../../../shared_components/notifications/NotificationContext'

import EverplanDownloadStatus from './EverplanDownloadStatus'
import {downloadWithFetch} from '../../../../../lib/fileDownload'

const POLLING_TIME_INTERVAL = 20000

const EverplanDownloadStatusController = props => {
  const [jobId, setJobId] = useState(null)
  const {alwaysNotify} = useNotificationContext()
  const prevDownloadRef = useRef(props.everplanBundleDownload)

  const clearDownloadPolling = () => {
    const bundle_url = props.everplanBundleDownload.get('download-url')

    if (jobId) {
      clearInterval(jobId)
      setJobId(null)
    }

    if (bundle_url) {
      downloadWithFetch(bundle_url)
      alwaysNotify.shortSuccess('The PDF download is complete.')

      const payload = {
        type: 'everplan-bundle-downloads',
        id: props.everplanBundleDownload.get('id')
      }

      setTimeout(() => props.deleteResource(payload), 1000) // 1 second
    }
  }

  const startDownloadPolling = everplanBundleDownloadId => {
    // clear any existing download polling before starting a new one.
    clearDownloadPolling()
    setJobId(setInterval(
      () => props.readEndpoint(`everplan-bundle-downloads/${everplanBundleDownloadId}`),
      POLLING_TIME_INTERVAL
    ))
  }

  useEffect(() => {
    const prevDownload = prevDownloadRef.current
    const currentDownload = props.everplanBundleDownload

    if (
      !currentDownload.isEmpty() &&
      !currentDownload.equals(prevDownload)
    ) {
      currentDownload.get('status') === 'ready' ?
        clearDownloadPolling() :
        startDownloadPolling(currentDownload.get('id'))
    }

    prevDownloadRef.current = currentDownload
  }, [props.everplanBundleDownload])

  useEffect(() => () => clearDownloadPolling(), [])

  return (
    <EverplanDownloadStatus
      everplanBundleDownload={props.everplanBundleDownload}
    />
  )
}

EverplanDownloadStatusController.propTypes = {
  deleteResource: PropTypes.func,
  everplanBundleDownload: PropTypes.instanceOf(Map),
  readEndpoint: PropTypes.func
}

const mapStateToProps = ({api}) => ({
  everplanBundleDownload: cleanResponse(api['everplan-bundle-downloads']).sortBy(
    download => download.get('created-at')
  ).last() || Map()
})

export default connect(mapStateToProps, {deleteResource, readEndpoint})(EverplanDownloadStatusController)
